import React, { useMemo, useState } from "react";
import styles from './index.module.scss'
import MessageHeader from "./compoments/messageHeader";
import { MessageContext } from "./context";
import { MessageItemType } from "./types";
import MessageRender from "./compoments/messageRender";
import Detail from "./compoments/detail";

const MessageCenter = () => {
  // 通用数据(站内信请求参数)
  const [selectedItem, setSelectedItem] = useState({brType: 1, msgType: 1,});
  // 控制消息详情显示/隐藏
  const [showPanel, setShowPanel] = useState(false); 
  // 当前点击的消息内容（用于 Detail 渲染）
  const [currentMessage, setCurrentMessage] = useState(null);
  // 重新请求站内信列表数据
  const [mutateList, setMutateList] = useState(() => () => {});
  // 是否编辑消息
  const [editor, setEditor] = useState(false)
  // 站内信列表数据
  const [list, setList] = useState<any[]>([]); 
  // 当前选中消息的 ID 组成的数组
  const [selectedIds, setSelectedIds] = useState<number[]>([]); 
  

  return(
    <MessageContext.Provider value={{ selectedItem, setSelectedItem, showPanel, setShowPanel, currentMessage,setCurrentMessage, mutateList, setMutateList, editor, setEditor, list, setList, selectedIds, setSelectedIds  }}>
      <div className={styles.messageCenter}>
        <MessageHeader />
        <MessageRender />

        {showPanel && currentMessage && (
          <Detail />
        )}
      </div>
    </MessageContext.Provider>
  )
}

export default MessageCenter